var utils           = require('./utils'),
	sticky_header   = require( './sticky-header' ),
	stone_filters   = require( './stone-filters' ),
	page_scroll_nav = require( './page-scroll-nav' );

var ocm = ( function( $ ) {

	var viewport   = utils.viewport_size();
	var $document  = $( document );
	var $html      = $( 'html' );
	var $ocm       = false;
	var animating  = false;
	var anim_speed = 500; // 0.5s

	var transition_event = 'transition';

	var _init = function() {
		viewport = utils.viewport_size();

		transition_event = utils.which_transition_event();

		$ocm = $( '#off-canvas-menu' );

		$( '.navbar-toggle' ).on( 'click', _ocm_toggle_click_event );
		$ocm.find( '.close' ).on( 'click', _ocm_close_click_event );

		$( window ).on( 'debouncedresize', _smart_resize_event );

		// $( window ).swipe( {
		// 	swipeLeft: _swipe_left_event,
		// 	swipeRight: _swipe_right_event,
		// 	threshold:0,
		// 	fingers:'all'
		// });
	};

	var _swipe_left_event = function( event ) {
		if ( $html.hasClass( 'ocm-right' ) ) {
			open_ocm();
		} else {
			close_ocm();
		}
	};

	var _swipe_right_event = function( event ) {
		if ( $html.hasClass( 'ocm-right' ) ) {
			close_ocm();
		} else {
			open_ocm();
		}
	};

	var _smart_resize_event = function( event ) {
		viewport = utils.viewport_size();

		if ( viewport.width >= 768 ) {
			$html.removeClass( 'ocm-open' );
		}
	};

	var _ocm_close_click_event = function( event ) {
		close_ocm();

		return false;
	};

	var _ocm_toggle_click_event = function( event ) {
		if ( stone_filters.is_open() ) {
			event.preventDefault();
			return;
		}

		if ( $html.hasClass( 'ocm-open' ) ) {
			close_ocm();
		} else {
			open_ocm();
		}

		return false;
	};

	var open_ocm = function() {
		if ( animating ) {
			return;
		}

		sticky_header.stick_header();
		setTimeout( _start_open_ocm, 25 );
	};

	var _start_open_ocm = function() {
		animating = true;
		$html.addClass( 'ocm-open' );
		show_logo_square();
		$document.on( 'click', _body_click_event );
		page_scroll_nav.hide_nav( 200 );

		if ( $( '.scroll-bottom' ).length > 0 ) {
			$( '.scroll-bottom' ).fadeOut( 200 );
		}

		setTimeout( function() {
			animating = false;
		}, anim_speed );
	};

	var close_ocm = function() {
		if ( animating ) {
			return;
		}

		setTimeout( _start_close_ocm, 25 );
	};

	var _start_close_ocm = function() {
		animating = true;

		$document.off( 'click', _body_click_event );

		$ocm.on( transition_event , _ocm_closed_event );

		$html.addClass( 'ocm-closing' );
		$html.removeClass( 'ocm-open' );

		setTimeout( function() {
			animating = false;
		}, anim_speed );

		setTimeout( function() {
			sticky_header. stick_header();
			hide_logo_square();
			page_scroll_nav.show_nav( 300 );

			if ( $( '.scroll-bottom' ).length > 0 ) {
				$( '.scroll-bottom' ).fadeIn( 300 );
			}
		}, 25 );
	};

	var _ocm_closed_event = function( event ) {
		$html.removeClass( 'ocm-closing' );

		$( this ).off( event );
	};

	var _body_click_event = function( event ) {
		if ( $( event.target ).closest( '#off-canvas-menu' ).length == 0 ) {
			close_ocm();
		}
	};

	var show_logo_square = function() {
		var $logo_wrapper = $( '#logo' );

		$logo_wrapper.removeClass( 'square-hidden' );
		$logo_wrapper.addClass( 'animating' );
		$logo_wrapper.find( '.logo-square' ).animate( { height : 90, opacity: 1 }, { queue: false, duration: anim_speed } );

		setTimeout( function() {
			$logo_wrapper.removeClass( 'animating' );
			$logo_wrapper.addClass( 'square-shown' );
		}, anim_speed );
	};

	var hide_logo_square = function() {
		var $logo_wrapper = $( '#logo' );

		$logo_wrapper.removeClass( 'square-shown' );
		$logo_wrapper.addClass( 'animating' );
		$logo_wrapper.find( '.logo-square' ).animate( { height : 0, opacity: 0 }, { queue: false, duration: 250 } );

		setTimeout( function() {
			$logo_wrapper.removeClass( 'animating' );
			$logo_wrapper.addClass( 'square-hidden' );
		}, 250 );
	};

	$( document ).ready( _init );

	return {
		hide_logo_square: hide_logo_square,
		show_logo_square: show_logo_square
	}

} )( jQuery );

module.exports = ocm;